import { IResourceModel } from "@xala/common-services";
import {
  Button,
  Col,
  Form,
  Icon,
  IFormValues,
  Input,
  Link,
  Row,
} from "@xala/common-ui";
import React from "react";
import { WithTranslation } from "react-i18next";
import * as TranslationsModule from "../../../../../Translations";
import { ApplicationHeaderItemPropertyModel } from "../../models";
import { ActionProperties } from "../ActionProperties";
import {
  ComponentPropertiesBase,
  IComponentPropertiesBaseProps,
  IComponentPropertiesBaseState,
} from "../ComponentPropertiesBase";
import "./ApplicationSectionMenuItemProperties.scss";
import { ApplicationSectionMenuItemPropertyModel } from "../../models/ApplicationSectionMenuItemPropertyModel";
import { SECTION_MENU_ITEM_ACTION_TYPES } from "../../../../helpers";

export interface IApplicationSectionMenuItemPropertiesStateProps {
  isProcessingData: boolean;
}

export interface IApplicationSectionMenuItemPropertiesDispatchProps {}

export interface IApplicationSectionMenuItemPropertiesOwnProps {}

export interface IApplicationSectionMenuItemPropertiesProps
  extends IApplicationSectionMenuItemPropertiesStateProps,
    IApplicationSectionMenuItemPropertiesDispatchProps,
    IApplicationSectionMenuItemPropertiesOwnProps,
    IComponentPropertiesBaseProps,
    WithTranslation {}

export interface IApplicationSectionMenuItemPropertiesState
  extends IComponentPropertiesBaseState {
  translationsBrowserVisible: boolean;
}

export class ApplicationSectionMenuItemProperties extends ComponentPropertiesBase<
  IApplicationSectionMenuItemPropertiesProps,
  IApplicationSectionMenuItemPropertiesState,
  ApplicationHeaderItemPropertyModel
> {
  public static defaultProps = {
    isProcessingData: false,
  };

  public state: Readonly<IApplicationSectionMenuItemPropertiesState> = {
    translationsBrowserVisible: false,
  };

  getPropertiesModel(): ApplicationSectionMenuItemPropertyModel {
    const { component } = this.props;
    const properties = new ApplicationSectionMenuItemPropertyModel();
    properties.init(component);

    return properties;
  }

  public onFinish = (values: IFormValues) => {
    const { component } = this.props;

    if (!component) {
      return;
    }

    component.Name = values.Name;
  };

  public onTitleTranslationKeyCancel = () => {
    this.setState({ translationsBrowserVisible: false });
  };

  public onTitleTranslationKeySelect = (row: IResourceModel) => {
    this.properties.TitleTranslationKey = row.ResourceKey;
    this.onPropertyChange("TitleTranslationKey");

    this.setState({ translationsBrowserVisible: false });
  };

  public onTitleTranslationKeyClear = () => {
    const { component, onComponentChange } = this.props;

    this.properties.TitleTranslationKey = undefined;
    this.properties.deleteProperty("TitleTranslationKey", component);

    if (onComponentChange) {
      onComponentChange(component);
    }
  };

  public renderTitleTranslationKeyProperty = () => {
    const { component, t } = this.props;
    const { translationsBrowserVisible } = this.state;

    let titleTranslationKeyView: React.ReactElement = this.properties
      .TitleTranslationKey ? (
      <label>
        <Link
          to={`${TranslationsModule.ROUTES.CONFIGURATION_TRANSLATION_DETAILS}/${this.properties.TitleTranslationKey}`}
        >
          {this.properties.TitleTranslationKey}
        </Link>
      </label>
    ) : (
      <label>{t("SELECT_TRANSLATION_KEY", "Select translation key")}</label>
    );

    return (
      <Form.Item
        name="TitleTranslationKey"
        label={t("TITLE_TRANSLATION_KEY", "Title Key")}
      >
        <Row gutter={8} style={{ justifyContent: "space-between" }}>
          <Col span={18}>
            <Form.Item>{titleTranslationKeyView}</Form.Item>
            <TranslationsModule.Components.TranslationsBrowserModal
              key={`TranslationsBrowser-${component.Id}`}
              visible={translationsBrowserVisible}
              onCancel={this.onTitleTranslationKeyCancel}
              onSelect={this.onTitleTranslationKeySelect}
            />
          </Col>
          <Col span={6} style={{ display: "flex", flex: "0" }}>
            {this.properties.TitleTranslationKey && (
              <Button
                icon={<Icon type="delete" />}
                onClick={this.onTitleTranslationKeyClear}
                style={{ marginRight: "8px" }}
              />
            )}
            <Button
              icon={<Icon type="edit" />}
              onClick={() => {
                this.setState({ translationsBrowserVisible: true });
              }}
            />
          </Col>
        </Row>
      </Form.Item>
    );
  };

  public renderTitleProperty = () => {
    const { t } = this.props;

    return (
      <Form.Item
        name="Title"
        label={t("MODEL_TITLE")}
        initialValue={this.properties.Title}
      >
        <Input
          placeholder={t("MODEL_TITLE_PLACEHOLDER")}
          onChange={(e) => {
            this.properties.Title = e.target.value;
            this.onPropertyChange("Title");
          }}
        />
      </Form.Item>
    );
  };

  public renderActionProperty = () => {
    const { component, onComponentChange } = this.props;

    return (
      <ActionProperties
        key={`Action-${component.Id}`}
        component={component}
        onComponentChange={onComponentChange}
        allowedActionTypes={SECTION_MENU_ITEM_ACTION_TYPES}
      />
    );
  };

  public render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
        lg: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 16 },
        lg: { span: 18 },
      },
    };

    return (
      <Form
        name="ApplicationSectionMenuItemProperties"
        {...formItemLayout}
        onFinish={this.onFinish}
      >
        <Row direction="column" justify="space-between" className="full-height">
          <Col>
            {this.renderTitleProperty()}
            {this.renderTitleTranslationKeyProperty()}
            {this.renderActionProperty()}
          </Col>
        </Row>
      </Form>
    );
  }
}
